import React from "react";
import Reveal from "./Reveal";

const reviews = [
  {
    text: "Infinity Research Work helped me complete my thesis on time with excellent data analysis support. Highly professional team and very responsive.",
    initials: "AK",
    name: "Aryan Kumar",
    role: "PhD Scholar, IIT Delhi",
  },
  {
    text: "My literature review was a mess. They restructured it completely in 3 days — amazing quality, and the consultation was genuinely insightful.",
    initials: "PR",
    name: "Priya Reddy",
    role: "PhD Research Scholar",
  },
  {
    text: "Publication support was flawless. They helped me get my paper published in a reputed journal — transparent, professional and affordable.",
    initials: "VT",
    name: "Vikram Tiwari",
    role: "PhD Scholar, Pune University",
  },
];

export default function Reviews() {
  return (
    <section id="reviews">
      <div className="wrap">
        <Reveal as="div" className="review-head">
          <div>
            <div className="eyebrow">Google Reviews</div>
            <h2 style={{ marginBottom: 0 }}>What our scholars say</h2>
          </div>
          <div style={{ marginLeft: "auto", textAlign: "right" }}>
            <div className="review-score">
              4.9 <span className="stars">★★★★★</span>
            </div>
            <div style={{ fontSize: ".82rem", color: "var(--ink-soft)" }}>
              Based on Google Reviews
            </div>
          </div>
        </Reveal>

        <div className="reviews-grid">
          {reviews.map((r) => (
            <Reveal as="div" className="review-card" key={r.name}>
              <span className="stars">★★★★★</span>
              <p>"{r.text}"</p>
              <div className="reviewer">
                <div className="avatar">{r.initials}</div>
                <div className="who">
                  <b>{r.name}</b>
                  <span>{r.role}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
